export const piedad = {
	nombre: "Piedad",
	dia: "Martes Santo",
	nombrecompleto:
		"Venerable, Real, Militar y Nacional Cofradía del Santísimo Cristo de la Piedad y María Santísima de las Lágrimas",
	sede: "Iglesia de Santiago Apóstol",
	pasos: 2,
	distancia: [821, 1580],
	penitentes: 180,
	cargadores: 124,
	web: "http://www.diariodecadiz.es/semana_santa/Piedad_0_1229277812.html",

	ida: [
		// CATEDRAL
		{ lng: -6.2956542, lat: 36.5297627 },
		{ lng: -6.2955335, lat: 36.529864 },
		{ lng: -6.2952894, lat: 36.5296808 },
		{ lng: -6.2950534, lat: 36.5296226 },
		{ lng: -6.2948683, lat: 36.5296161 },
		{ lng: -6.2946095, lat: 36.5295557 },
		{ lng: -6.2943486, lat: 36.5305536 },
		{ lng: -6.2942058, lat: 36.5305579 },
		{ lng: -6.2939939, lat: 36.5305903 },
		{ lng: -6.2935004, lat: 36.5307336 },
		{ lng: -6.2929103, lat: 36.5310817 },
		{ lng: -6.2922102, lat: 36.5302875 },
		{ lng: -6.2928741, lat: 36.5299717 },
		{ lng: -6.2932965, lat: 36.5297346 },
		{ lng: -6.2935929, lat: 36.5297012 },
		{ lng: -6.2945612, lat: 36.5296366 },
		{ lng: -6.2946001, lat: 36.5295137 },
		{ lng: -6.2951164, lat: 36.5295213 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956971, lat: 36.5291398 },
		{ lng: -6.2955174, lat: 36.5295838 },
		{ lng: -6.2954074, lat: 36.5297562 },
		{ lng: -6.2956649, lat: 36.5299459 },
		{ lng: -6.2952921, lat: 36.5303424 },
		{ lng: -6.2950051, lat: 36.5308403 },
		{ lng: -6.2949219, lat: 36.5308392 },
		{ lng: -6.2949246, lat: 36.5314524 },
		{ lng: -6.2964803, lat: 36.5317843 },
		{ lng: -6.2964106, lat: 36.5318619 },
		{ lng: -6.2967955, lat: 36.5325321 },
		{ lng: -6.2965634, lat: 36.5327908 },
		{ lng: -6.296424, lat: 36.5329352 },
		{ lng: -6.2962738, lat: 36.5332455 },
		{ lng: -6.296322, lat: 36.5332865 },
		{ lng: -6.2962711, lat: 36.5339373 },
		{ lng: -6.2954772, lat: 36.5340192 },
		{ lng: -6.2940745, lat: 36.5324218 },
		{ lng: -6.2929244, lat: 36.5310876 },
		{ lng: -6.2935034, lat: 36.5307419 },
		{ lng: -6.2939993, lat: 36.5305984 },
		{ lng: -6.2942018, lat: 36.5305671 },
		{ lng: -6.2943614, lat: 36.5305617 },
		{ lng: -6.2946195, lat: 36.5295671 },
		{ lng: -6.2948643, lat: 36.5296263 },
		{ lng: -6.2950527, lat: 36.5296306 },
		{ lng: -6.2952847, lat: 36.5296905 },
		{ lng: -6.2955348, lat: 36.5298801 },
		{ lng: -6.2956662, lat: 36.5297697 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-27T17:30",
			latlng: [36.52973, -6.29565]
		},
		{
			name: "Nueva",
			hora: "2018-03-27T18:35",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-27T19:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-27T20:35",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-27T21:00",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-27T21:10",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		["Plaza de Pío XII", "Cobos", "Cristóbal Colon", "Nueva"],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Cristóbal Colón",
			"Cobos",
			"Plaza de Pío XII"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/piedad.js